export default __webpack_public_path__ + "static/media/Logo_Small.fb6513c2.svg";